import { createSlice } from "@reduxjs/toolkit";
import { fetchLicense } from "../Utilities/licenseService";

export const getLicenseData = (language = 'he') => {
  return async (dispatch) => {
    try {
      const data = await fetchLicense(language);
      dispatch(licenseActions.setLicenseData(data));
    } catch (error) {
      console.error('Error loading license:', error);
      // Set default data on error is handled by fetchLicense itself
    }
  };
};

const licenseSlice = createSlice({
  name: "license",
  initialState: {
    licenseData: null,
  },
  reducers: {
    setLicenseData: (state, action) => {
      state.licenseData = action.payload;
    },
  },
});

export const licenseActions = licenseSlice.actions;
export default licenseSlice;
